export enum Platform {
  coaching = 'coaching',
  mentoring = 'mentoring',
}
